module.exports = __webpack_public_path__ + "img/or_logo_header.56d02938.png";